import React from 'react'
import { useSelector } from 'react-redux'

const Modal: React.FC = () => {
  const modal = useSelector((state: any) => state.modal)

  if (!modal || !modal.show) {
    return null
  }

  return (
    <div className="lightbox_wrapper">
      <div className="lightbox_content">
        <h1>{modal.heading}</h1>
        {modal.body}
        {modal.button}
      </div>
    </div>
  )
}

export default Modal
